import classNames from "classnames";
import { FC } from "react";
import { GroupProps } from "react-select";
import { OptionItem } from "../../OptionItem";
import styles from "./styles.module.scss";

/**
 * The group component.
 */
export const Group: FC<GroupProps<OptionItem | null>> = (props) => {
  const { children, Heading, label, headingProps } = props;

  return (
    <div className={classNames(styles.Group, "group")} role="group" >
      <Heading {...props} {...headingProps}>
        {label}
      </Heading>
      {children}
    </div>
  );
};
